import request from '@/util/request'


export const capaSubmit = (data) => request.post('/api/capaSubmit', data);  //提交CAPA审批

export const capaUploadsCapaBackgroundFile = (data) => request.post('/api/capaUploadsCapaBackgroundFile', data);  //上传CAPA背景文件

export const capaUploadsCapaBackgroundFileDel = (data) => request.post('/api/capaUploadsCapaBackgroundFileDel', data);  //删除CAPA背景文件

export const capaUploadsCapaCorrectionsFile = (data) => request.post('/api/capaUploadsCapaCorrectionsFile', data);  //上传更正文件

export const capaUploadsCapaCorrectionsFileDel = (data) => request.post('/api/capaUploadsCapaCorrectionsFileDel', data);  //删除更正文件

export const capaUploadsCapaAffectedArticle = (data) => request.post('/api/capaUploadsCapaAffectedArticle', data);  //上传受问题、关注点、想法或机遇影响的文章

export const capaUploadsCapaAffectedArticleDel = (data) => request.post('/api/capaUploadsCapaAffectedArticleDel', data);  //删除受问题、关注点、想法或机遇影响的文章

export const ApplyHandle = (data) => request.post('/api/ApplyHandle', data);  //审批

export const capaActivityLogAdd = (data) => request.post('/api/capaActivityLogAdd', data);  //调查活动日志添加/编辑

export const capaUploadsActivityLogFile = (data) => request.post('/api/capaUploadsActivityLogFile', data);  //上传调查活动日志附件

export const capaUploadsActivityLogFileDel = (data) => request.post('/api/capaUploadsActivityLogFileDel', data);  //删除调查活动日志附件

export const capaActivityLogDetail = (data) => request.post('/api/capaActivityLogDetail', data);  //调查活动日志详情

export const capaRootCauseAdd = (data) => request.post('/api/capaRootCauseAdd', data);  //根本原因添加/编辑

export const capaRootCauseDetail = (data) => request.post('/api/capaRootCauseDetail', data);  //根本原因详情

export const capaRootCauseDel = (data) => request.post('/api/capaRootCauseDel', data);  //删除根本原因

export const capaUploadsRootCauseFile = (data) => request.post('/api/capaUploadsRootCauseFile', data);  //上传根本原因附件

export const capaUploadsRootCauseFileDel = (data) => request.post('/api/capaUploadsRootCauseFileDel', data);  //删除根本原因附件

export const capaRootCauseActionAdd = (data) => request.post('/api/capaRootCauseActionAdd', data);  //CAPA操作添加/编辑

export const capaRootCauseActionDetail = (data) => request.post('/api/capaRootCauseActionDetail', data);  //CAPA操作详情

export const capaRootCauseActionDel = (data) => request.post('/api/capaRootCauseActionDel', data);  //删除CAPA操作

export const capaUploadsRootCauseActionFile = (data) => request.post('/api/capaUploadsRootCauseActionFile', data);  //上传CAPA操作附件

export const capaUploadsRootCauseActionFileDel = (data) => request.post('/api/capaUploadsRootCauseActionFileDel', data);  //删除CAPA操作附件

export const capaImpacts = (data) => request.post('/api/capaImpacts', data);  //描述解决方案的影响

export const capaVerification = (data) => request.post('/api/capaVerification', data);  //编辑CAPA有效性验证计划

export const capaActionVerification = (data) => request.post('/api/capaActionVerification', data);  //编辑行动核查结果 & 编辑CAPA有效性验证结果

export const capaUploadsActionVerificationFile = (data) => request.post('/api/capaUploadsActionVerificationFile', data);  //上传行动核查附件

export const capaUploadsActionVerificationFileDel = (data) => request.post('/api/capaUploadsActionVerificationFileDel', data);  //删除行动核查附件

export const capaVerificationResults = (data) => request.post('/api/capaVerificationResults', data);  //编辑CAPA有效性验证结果

export const capaUploadsVerificationResultsFile = (data) => request.post('/api/capaUploadsVerificationResultsFile', data);  //上传CAPA有效性验证附件

export const capaUploadsVerificationResultsFileDel = (data) => request.post('/api/capaUploadsVerificationResultsFileDel', data);  //删除CAPA有效性验证附件

